import {
    VERIFY_LICENSE_REQUEST,
    VERIFY_LICENSE_SUCCESS,
    VERIFY_LICENSE_ERROR
  } from "./VerifyLicenseTypes";
  
  const initialState = {
    loading: false,
    isSubmitted: false,
    successMessage: "",
    errorMessage: "",
    licenseStatus: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case VERIFY_LICENSE_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case VERIFY_LICENSE_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          licenseStatus: action.payload,
          successMessage: "License verified successfully!",
          errorMessage: ""
        };
      case VERIFY_LICENSE_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          licenseStatus: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  